import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import App from './App';
import store from './store';
import { sessionExpired } from './store/authSlice';
import { setUnauthorisedHandler } from './services/api';
import './index.css';

/**
 * When a request comes back 401 and cannot be refreshed, the api layer calls
 * this. Wiring it here rather than inside the api module keeps that module free
 * of a dependency on the store, which would otherwise be a cycle.
 */
setUnauthorisedHandler(() => store.dispatch(sessionExpired()));

/**
 * HashRouter, not BrowserRouter.
 *
 * The packaged Electron app loads index.html from the file system, where there
 * is no server to answer a deep path like /pos on a reload. A hash route needs
 * nothing from the host, so the same build works served over HTTP and opened as
 * a file.
 */
ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <Provider store={store}>
            <HashRouter>
                <App />
                <Toaster
                    position="top-center"
                    toastOptions={{
                        // A till is read at arm's length across a counter.
                        style: { fontSize: '0.95rem', padding: '12px 16px', maxWidth: '520px' },
                        success: { duration: 2500 },
                        // Errors stay longer: they usually need an action.
                        error: { duration: 6000 }
                    }}
                />
            </HashRouter>
        </Provider>
    </React.StrictMode>
);
